interface HSPCriteria {
  [key: string]: string[];
}

export const parseHSPCriteria = (config: string): HSPCriteria => {
  const parsedCriteria: HSPCriteria = {};

  const configItems = config
    ?.toLowerCase()
    .split(';')
    .filter((item) => !!item);

  configItems.forEach((configItem) => {
    const [key, value] = configItem.split(':');
    parsedCriteria[key] = value?.split(',').filter((item) => !!item);
  });

  return parsedCriteria;
};

export const criteriaMatches = (HSPCriteria: HSPCriteria, compareItem: HSPCriteria): boolean => {
  let matchingCriteriaItemsLength = 0;

  for (const key in compareItem) {
    if (Object.prototype.hasOwnProperty.call(compareItem, key)) {
      const criteriaHasRequiredValues = compareItem[key].every((val) =>
        HSPCriteria[key]?.includes(val)
      );
      const criteriaHasNotExcludedRequiredValues =
        !HSPCriteria[`no-${key}`] ||
        compareItem[key].some((val) => !HSPCriteria[`no-${key}`].includes(val));

      if (
        criteriaHasNotExcludedRequiredValues &&
        (!HSPCriteria[key] || criteriaHasRequiredValues)
      ) {
        matchingCriteriaItemsLength++;
      }
    }
  }

  return matchingCriteriaItemsLength === Object.keys(compareItem).length;
};
